/**
 * @generated SignedSource<<41bffacaf0f84e4b4e6eabb222b29db9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeSeriesTable$data = {
  readonly dimensions: ReadonlyArray<{
    readonly color: string | null;
    readonly id: string;
    readonly label: string;
  }>;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly formattedDate: string;
      readonly values: ReadonlyArray<{
        readonly dimensionId: string;
        readonly value: number | null;
      }>;
    };
  }>;
  readonly " $fragmentType": "TimeSeriesTable";
};
export type TimeSeriesTable$key = {
  readonly " $data"?: TimeSeriesTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSeriesTable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSeriesAnalyticsNodeDimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSeriesAnalyticsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSeriesAnalyticsNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formattedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSeriesAnalyticsNodeDimensionValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dimensionId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSeriesAnalyticsConnection",
  "abstractKey": null
};

(node as any).hash = "cf5bd343e86894d262aa71c423860b76";

export default node;
